import { Badge } from '@/components/ui/badge';

type PaymentStatus = 'pending' | 'paid' | 'cancelled';

const statusStyles: Record<PaymentStatus, string> = {
  pending: 'border-transparent bg-[#FFF7ED] text-[#C2410C]',
  paid: 'border-transparent bg-[#F0FDF4] text-[#15803D]',
  cancelled: 'border-transparent bg-[#FEF2F2] text-[#B91C1C]',
};

const statusLabels: Record<PaymentStatus, string> = {
  pending: '입금 대기',
  paid: '입금 확인',
  cancelled: '취소',
};

interface OrderStatusBadgeProps {
  status: PaymentStatus;
}

export default function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
  return (
    <Badge
      className={`rounded-md px-2.5 py-1 text-xs font-semibold transition-colors duration-150 ${statusStyles[status]}`}
    >
      {statusLabels[status]}
    </Badge>
  );
}
